import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {IAssetView} from '../schema';

/**
 * `getViewObjectsForAsset` request params
 * (what is used to send to server)
 */
export type GetViewObjectsForAssetRequestOptions = {
	id: number;
};

/**
 * `getViewObjectsForAsset` request
 * (what gets sent to the server)
 */
export type GetViewObjectsForAssetRequest = [
	GetViewObjectsForAssetRequestOptions['id'],
];

/**
 * `getViewObjectsForAsset` response
 * (what comes back from the server)
 */
export type GetViewObjectsForAssetResponse =
	SuccessResponse<GetViewObjectsForAssetResult>;

/**
 * `getViewObjectsForAsset` result
 * (what is utilized from the server response)
 */
export type GetViewObjectsForAssetResult = IAssetView[];

export const getViewObjectsForAssetEndpoint = 'getViewObjectsForAsset';

/**
 * Get asset views
 * @param fetchParams Fetch params
 */
export const getViewObjectsForAsset = async (
	{id}: GetViewObjectsForAssetRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetViewObjectsForAssetRequest = [id];

	return client
		.post<GetViewObjectsForAssetResponse>(
			getViewObjectsForAssetEndpoint,
			requestParams,
			{signal},
		)
		.then(getResponseResults);
};

export default getViewObjectsForAsset;
